import { ObservableArray, View } from "binder"
import { ProductLineItem, WarehouseKeepingEditorViewModel } from "./warehouseKeepingEditor-viewModel"

export class WarehouseKeepingEditorView extends View<WarehouseKeepingEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-4805C2F5-6AE6-4A44-B676-3DC72B2B790A"
    }
    loadHtml(): string {
        let element = require('./warehouseKeepingEditor.html').default;
        let style = require('./warehouseKeepingEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productLineItems(v: ObservableArray<ProductLineItem>) { this._productLineItem = v; } public get productLineItems(): ObservableArray<ProductLineItem> { return this._productLineItem; } private _productLineItem: ObservableArray<ProductLineItem>;
    public set canFinalized(v: boolean) { this._canFinalized = v; } public get canFinalized(): boolean { return this._canFinalized;} private _canFinalized: boolean;
    public set canCounting(v: boolean) { this._canCounting = v; } public get canCounting(): boolean { return this._canCounting;} private _canCounting: boolean;


    back() {
        this.dataContext.back();
    }

    saveFirstCount() {
        this.dataContext.saveFirstCount();
    }

    confirmFirstCount() {
        this.dataContext.confirmFirstCount();
    }

    finalConfirm() {
        this.dataContext.finalConfirm();
    }

    downloadExcelFile(){
        this.dataContext.downloadExcelFile();
    }

    uploadExcelFile(){
        this.dataContext.uploadExcelFile();
    }
}



